import config from "config";

import { getLookerEmbedSDKReq } from "./authLib";

export const generateLookerEmbedSDKParams = async (hubId) => {
  const { headers } = await getLookerEmbedSDKReq({ name: "hub", value: hubId });

  return {
    host: config.lookerHost,
    config: {
      url: `${config.gateway.URL}/looker/auth/`,
      headers: headers,
      params: [
        {
          name: "timezone",
          value: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
      ],
    },
  };
};

export default generateLookerEmbedSDKParams;
